import React, { Component } from 'react'
import PopupWindow from './PopupWindow'
import { connect } from 'react-redux';
import * as StatisticActions from '../../actions/statisticActions';
import { bindActionCreators } from 'redux';
import Checkbox from './Checkbox'
import StatsBaseWindow from './StatsBaseWindow'
import Pitch from '../Pitch/Pitch'

class PitchWindow extends StatsBaseWindow {

    static propTypes = {
        top: React.PropTypes.number,
        left: React.PropTypes.number
    }

    static defaultProps = {
        top: 10,
        left: 10
    }

    constructor(props) {
        super(props);
        this.pitchWidth = 0;
        this.pitchHeight = 0;
        this.pitchIdent = 0;
    }

    componentDidMount() {
        if(this.props.is_cut_down === false) {
            this.calculateHtmlPositions();
            this.forceUpdate();
        }
    }

    componentWillReceiveProps(nextProps){
        if(this.props.width != nextProps.width || this.props.height != nextProps.height || this.props.is_cut_down != nextProps.is_cut_down) {
            if(this.props.is_cut_down === false) {
                this.calculateHtmlPositions();
                this.forceUpdate();
            }
        }
    }

    calculateHtmlPositions() {
        let el = document.getElementById("popup2dpitch");
        let style = el.currentStyle || window.getComputedStyle(el);
        let padding = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight)
        this.pitchWidth = (el.offsetWidth - padding);
        this.pitchIdent = this.pitchWidth * 50.0 / 970.0;
        this.pitchHeight = (this.pitchWidth - 2*this.pitchIdent) * 450 / 720 + 2*this.pitchIdent;

        let padding2 = parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
    }

    onResize(width, height) {
        this.calculateHtmlPositions();
        this.forceUpdate();
    }

    renderHeader() {
        return `${this.props.homeTeamName} ${this.props.homeGoals}:${this.props.awayGoals} ${this.props.awayTeamName}`;
    }

    render() {
        const { close_stats_window } = this.props.StatisticActions;
        
        return (<PopupWindow header={this.renderHeader()} resizable={true} width={this.props.width} height={this.props.height} zIndex={5} is_cut_down={this.props.is_cut_down} onDragStop={this.onDragStop.bind(this)} onResizeStop={this.onResizeStop.bind(this)} onResize={this.onResize.bind(this)} onToggleCutDown={this.onToggleCutDown.bind(this)} top={this.position.top}  left={this.position.left} onClose={() => (close_stats_window(this.props.id))}>
                    <div id="popup2dpitch">
                        <Pitch windowMode={true} width={this.pitchWidth} height={this.pitchHeight} ident={this.pitchIdent} weather={this.props.weather} />
                    </div>
                </PopupWindow>)
    }
}

function mapStateToProps(state, ownProps) {
    return {
        position: state.statisticWindows.pitch.position,
        is_cut_down: state.statisticWindows.pitch.is_cut_down,
        height: state.statisticWindows.pitch.height,
        width: state.statisticWindows.pitch.width,
        weather: state.weather,
        homeTeamName: state.HomeTeam.Name,
        awayTeamName: state.AwayTeam.Name,
        homeGoals: state.Stats.Score.Home,
        awayGoals: state.Stats.Score.Away
    };
}

function mapDispatchToProps(dispatch) {
    return {
        StatisticActions: bindActionCreators(StatisticActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PitchWindow)



/** WEBPACK FOOTER **
 ** ./src/components/PopupStats/PitchWindow.js
 **/